export default __webpack_public_path__ + "static/huawei_gallery_badge_sc-5adc104c78225403b9f13e71fe1c0d33.svg";